<template>
    <transition name="toast-fade">
        <div v-if="show"
             class="fixed right-4 top-4 z-[10001] w-[min(24rem,calc(100vw-2rem))]"
             role="status"
             aria-live="polite"
             aria-atomic="true">
            <div class="foxy-modal p-4 shadow-xl">
                <div class="flex items-start gap-3">
                    <div class="min-w-0 flex-1">
                        <div class="font-bold text-foxy-text">{{ title }}</div>
                        <p class="mt-1 whitespace-pre-wrap text-sm text-foxy-text-secondary">{{ message }}</p>
                    </div>
                    <button type="button"
                            class="foxy-icon-button !h-8 !w-8 shrink-0"
                            aria-label="Закрити сповіщення"
                            @click="dismiss">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ToastNotification',
    data() {
        return {
            show: false,
            type: 'info',
            title: '',
            message: '',
            autoCloseTimer: null,
            generation: 0,
            activeGeneration: null,
            resolve: null,
        };
    },
    beforeDestroy() {
        this.clearAutoCloseTimer();
        this.generation += 1;
        this.activeGeneration = null;
        this.resolve = null;
    },
    methods: {
        alert(message, title = 'Повідомлення', type = 'info') {
            this.clearAutoCloseTimer();
            this.resolve?.(false);

            const generation = ++this.generation;
            this.activeGeneration = generation;
            this.type = type;
            this.title = title;
            this.message = message;
            this.show = true;

            return new Promise((resolve) => {
                this.resolve = resolve;
                this.autoCloseTimer = setTimeout(() => {
                    this.close(generation, true);
                }, 6000);
            });
        },
        dismiss() {
            this.close(this.activeGeneration, true);
        },
        close(generation, result) {
            if (generation === null || generation !== this.activeGeneration) return;
            const resolve = this.resolve;
            this.clearAutoCloseTimer();
            this.activeGeneration = null;
            this.resolve = null;
            this.show = false;
            resolve?.(result);
        },
        clearAutoCloseTimer() {
            if (this.autoCloseTimer === null) return;
            clearTimeout(this.autoCloseTimer);
            this.autoCloseTimer = null;
        },
    },
};
</script>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
    transform: translateY(-0.5rem);
}
</style>
